module.exports = __webpack_public_path__ + "dcf40cfeacec4e1c91ffc267c91920f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/northwestern_university_2023_chart.png
// module id = 1705
// module chunks = 0